import { followingSidebar } from '../utils/sidebar.utils.js';

if (document.querySelector('.search-sec')) {
  const sidebar = document.querySelector('#sidebar');
  const contentSticky = document.querySelector('#content-sticky');
  const filtersBtn = document.querySelector('#filters-btn');
  const contentResult = document.querySelector('#content-result');

  if (sidebar && window.innerWidth >= 852) {
    followingSidebar({ sidebar, contentSticky });
  }

  if (filtersBtn) {
    filtersBtn.addEventListener('click', () => {
      filtersBtn.classList.toggle('is-open-filters');
      sidebar.classList.toggle('is-open-filters');
      contentSticky.classList.toggle('is-open-filters');
      contentResult.classList.toggle('is-open-filters');
    });

    contentResult.addEventListener('click', () => {
      if (contentResult.classList.contains('is-open-filters')) {
        filtersBtn.classList.remove('is-open-filters');
        sidebar.classList.remove('is-open-filters');
        contentSticky.classList.remove('is-open-filters');
        contentResult.classList.remove('is-open-filters');
      }
    });
  }
}

if (document.querySelector('.search-jobs-sec')) {
  const searchResultsBox = document.querySelector('#search_results_box');
  const isTouchTiltDisabled = () =>
    window.matchMedia('(hover: none), (pointer: coarse)').matches;

  const throttle = (callback, delay = 200) => {
    let isThrottled = false;
    let pendingArgs = null;
    let pendingContext = null;

    const run = () => {
      callback.apply(pendingContext, pendingArgs || []);
      pendingArgs = null;
      pendingContext = null;
    };

    return function throttledCallback(...args) {
      if (isThrottled) {
        pendingArgs = args;
        pendingContext = this;
        return;
      }

      callback.apply(this, args);
      isThrottled = true;

      setTimeout(() => {
        isThrottled = false;

        if (pendingArgs) {
          run();
          isThrottled = true;

          setTimeout(() => {
            isThrottled = false;
          }, delay);
        }
      }, delay);
    };
  };

  const alignJobsCardTitles = () => {
    if (!searchResultsBox) {
      return;
    }

    const cards = Array.from(
      searchResultsBox.querySelectorAll('.job-card.second-type')
    );

    if (!cards.length) {
      return;
    }

    cards.forEach((card) => {
      const title = card.querySelector('.job-card__title');

      if (title) {
        title.style.minHeight = '';
      }
    });

    const visibleCards = cards.filter((card) => card.offsetParent !== null);

    if (!visibleCards.length) {
      return;
    }

    const gridTemplateColumns = window.getComputedStyle(searchResultsBox).gridTemplateColumns;
    const columnsCount = Math.max(
      1,
      gridTemplateColumns
        .split(' ')
        .map((column) => column.trim())
        .filter(Boolean).length
    );

    for (let index = 0; index < visibleCards.length; index += columnsCount) {
      const rowCards = visibleCards.slice(index, index + columnsCount);
      const titles = rowCards
        .map((card) => card.querySelector('.job-card__title'))
        .filter(Boolean);

      if (!titles.length) {
        continue;
      }

      let maxHeight = 0;

      titles.forEach((title) => {
        maxHeight = Math.max(maxHeight, title.offsetHeight);
      });

      titles.forEach((title) => {
        title.style.minHeight = `${maxHeight}px`;
      });
    }
  };

  const alignJobsCardTexts = () => {
    if (!searchResultsBox) {
      return;
    }

    const cards = Array.from(
      searchResultsBox.querySelectorAll('.job-card.second-type')
    );

    if (!cards.length) {
      return;
    }

    cards.forEach((card) => {
      const text = card.querySelector('.job-card__text');

      if (text) {
        text.style.minHeight = '';
      }
    });

    const visibleCards = cards.filter((card) => card.offsetParent !== null);

    if (!visibleCards.length) {
      return;
    }

    const gridTemplateColumns = window.getComputedStyle(searchResultsBox).gridTemplateColumns;
    const columnsCount = Math.max(
      1,
      gridTemplateColumns
        .split(' ')
        .map((column) => column.trim())
        .filter(Boolean).length
    );

    for (let index = 0; index < visibleCards.length; index += columnsCount) {
      const rowCards = visibleCards.slice(index, index + columnsCount);
      const texts = rowCards
        .map((card) => card.querySelector('.job-card__text'))
        .filter(Boolean);

      if (!texts.length) {
        continue;
      }

      let maxHeight = 0;

      texts.forEach((text) => {
        maxHeight = Math.max(maxHeight, text.offsetHeight);
      });

      texts.forEach((text) => {
        text.style.minHeight = `${maxHeight}px`;
      });
    }
  };

  const reinitJobsSearchTilt = () => {
    if (!searchResultsBox) {
      return;
    }

    const tiltElements = Array.from(searchResultsBox.querySelectorAll('[data-tilt]'));

    if (!tiltElements.length) {
      return;
    }

    if (isTouchTiltDisabled()) {
      tiltElements.forEach((element) => {
        if (element.vanillaTilt && typeof element.vanillaTilt.destroy === 'function') {
          element.vanillaTilt.destroy();
        }

        element.removeAttribute('data-tilt');
        element.removeAttribute('data-tilt-max');
        element.removeAttribute('data-tilt-speed');
        element.removeAttribute('data-tilt-perspective');
        element.removeAttribute('data-tilt-glare');
        element.removeAttribute('data-tilt-max-glare');
      });

      return;
    }

    if (typeof window.VanillaTilt === 'undefined') {
      return;
    }

    tiltElements.forEach((element) => {
      if (element.vanillaTilt) {
        return;
      }

      window.VanillaTilt.init(element);
    });
  };

  window.reinitJobsSearchTilt = reinitJobsSearchTilt;

  const throttledAlignJobsCardTitles = throttle(alignJobsCardTitles, 200);
  const throttledAlignJobsCardTexts = throttle(alignJobsCardTexts, 200);

  reinitJobsSearchTilt();
  alignJobsCardTitles();
  alignJobsCardTexts();
  window.addEventListener('load', throttledAlignJobsCardTitles);
  window.addEventListener('load', throttledAlignJobsCardTexts);
  window.addEventListener('resize', throttledAlignJobsCardTitles);
  window.addEventListener('resize', throttledAlignJobsCardTexts);

  if (document.fonts?.ready) {
    document.fonts.ready.then(() => {
      reinitJobsSearchTilt();
      alignJobsCardTitles();
      alignJobsCardTexts();
    });
  }

  if (searchResultsBox) {
    const resultsObserver = new MutationObserver(() => {
      throttledAlignJobsCardTitles();
      throttledAlignJobsCardTexts();
    });

    resultsObserver.observe(searchResultsBox, {
      childList: true,
    });
  }
}

/*if (document.getElementsByClassName('job-search-section__form')[0]) {
  const checkboxesTypes = document.querySelectorAll(
    'input[type="checkbox"][name="type[]"], input[type="checkbox"][name="type_second[]"]'
  );

  function syncCheckboxes(event) {
    const targetCheckbox = event.target;
    const isChecked = targetCheckbox.checked;
    const targetValue = targetCheckbox.value;

    checkboxesTypes.forEach((checkbox) => {
      if (checkbox.value === targetValue) {
        checkbox.checked = isChecked;
      }
    });
  }

  checkboxesTypes.forEach((checkbox) => {
    checkbox.addEventListener('change', syncCheckboxes);
  });

  const checkboxesSectors = document.querySelectorAll(
    'input[type="checkbox"][name="sector[]"], input[type="checkbox"][name="sector_second[]"]'
  );

  function syncCheckboxesSectors(event) {
    const targetCheckbox = event.target;
    const isChecked = targetCheckbox.checked;
    const targetValue = targetCheckbox.value;

    checkboxesSectors.forEach((checkbox) => {
      if (checkbox.value === targetValue) {
        checkbox.checked = isChecked;
      }
    });
  }

  checkboxesSectors.forEach((checkbox) => {
    checkbox.addEventListener('change', syncCheckboxesSectors);
  });
}*/
